import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import { updateBranding } from 'shared/helpers/adsAndMetrics';
import { BannersBuffer } from 'shared/components/BannerAll';
import ChooseLanguageDialog from 'shared/components/ChooseLanguageDialog/ChooseLanguageDialog';
import LazyLoad from 'react-lazyload';
import { Googletag, ignoreTopBanner } from 'shared/modules';

import { connect } from 'react-redux';
import 'normalize.css/normalize.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.min.css';
import 'react-nprogress/nprogress.css';
import 'slick-carousel/slick/slick.css';
import 'global_styles/desktop.css';
import Header from '../Header';

import SubHeader from '../SubHeader';
import Footer from '../Footer/Footer';
import FooterLeasing from '../Footer/FooterLeasing';
import NotificationBar from './NotificationBar/NotificationBar';

// eslint-disable-next-line css-modules/no-unused-class
import s from './Layout.css';

const isClient = process.env.BROWSER;
let localCurrentPage = '';

class Layout extends React.Component {
  static propTypes = {
    history: PropTypes.shape(),
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
    navLinks: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        route: PropTypes.string,
      }),
    ),
    currentRoute: PropTypes.string,
    including: PropTypes.bool,
    personalSubheader: PropTypes.bool,
    hideLocations: PropTypes.bool,
    footer: PropTypes.string,
  };
  static defaultProps = {
    history: {},
    currentRoute: null,
    navLinks: null,
    withBranding: false,
    personalSubheader: false,
    including: true,
    targetingArguments: {},
    shouldInitAds: true,
    hideLocations: false,
    string: '',
    footer: '',
  };

  componentDidMount() {
    if (!isClient) return;
    const targetNode = window.document.body;
    const bannerTopAB = window.document.getElementById('banner-top-AB');
    const changeObserver = () => {
      if (targetNode.style.backgroundImage) {
        window.document.getElementById('bodyABIdBlock').style.margin = '68px auto 0  auto';
      } else if (bannerTopAB && Number(bannerTopAB.clientHeight) > 30) {
        // bannerTopAB.style.marginTop = '20px';
        bannerTopAB.style.display = 'flex';
      }
    };

    const observer = new MutationObserver(changeObserver);
    const observerTop = new MutationObserver(changeObserver);
    observer.observe(targetNode, { attributes: true, childList: true });
    if (bannerTopAB) {
      observerTop.observe(bannerTopAB, { attributes: true, childList: true });
    }
    // updateBranding();
  }

  componentDidUpdate() {
    const { currentPath } = this.props.history;
    if (
      process.env.BROWSER &&
      `${location.pathname}${location.search}` !== currentPath &&
      currentPath !== localCurrentPage
    ) {
      // updateBranding();
      localCurrentPage = currentPath;
    }
  }

  getFooter() {
    const { hideLocations, footer } = this.props;
    if (footer === 'leasing') return <FooterLeasing hideLocations={hideLocations} />;
    return <Footer hideLocations={hideLocations} />;
  }

  render() {
    const {
      navLinks,
      currentRoute,
      including,
      personalSubheader,
      history: { currentPath },
    } = this.props;

    return (
      <div id={!navLinks ? `fakeSubHeader` : ''} className={s.root}>
        <NotificationBar />

        <Header />

        {navLinks && !!navLinks.length && (
          <SubHeader
            including={including}
            navLinks={navLinks}
            currentRoute={currentRoute}
            personalSubheader={personalSubheader}
          />
        )}
        {!new Set(ignoreTopBanner).has(currentPath) && !/\/edit\//.test(currentPath) ? (
          <div className={s.brandingAdv} id="banner-top-AB">
            <LazyLoad>
              <Googletag id="div-gpt-ad-1514298874616-0" />
            </LazyLoad>
          </div>
        ) : (
          ''
        )}
        <div className={s.layout} id="bodyABIdBlock">
          {this.props.children}
        </div>

        {/* <Warning /> */}
        <main className={s.mainFooter}>{this.getFooter()}</main>
        <BannersBuffer />
        {isClient && <ChooseLanguageDialog />}
      </div>
    );
  }
}

export default withStyles(s)(
  connect(({ history }) => ({
    history,
  }))(Layout),
);



// WEBPACK FOOTER //
// ./src/desktop/components/Layout/Layout.js